import request from '@/utils/request'

// 관계법령 관리대장 목록 조회
export function getRelatedLegisManageList(params, isProgress) {
  return request({
    url: `/api/getRelatedLegisManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 관계법령 관리대장 저장
export function saveRelatedLegisManageList(params, isProgress) {
  return request({
    url: `/api/saveRelatedLegisManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

// 관계법령 관리대장 삭제
export function deleteRelatedLegisManageList(params, isProgress) {
  return request({
    url: `/api/deleteRelatedLegisManageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' },
  })
}

// 관계법령 관리대장 변경이력 조회
export function getRelatedLegisManageHistory(params, isProgress) {
  return request({
    url: `/api/getRelatedLegisManageHistory`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
